interface SponsorLogosProps {
  variant: 'hacker' | 'staff';
}

// Each lockup is a solid block masked by the logo file, so one asset serves both the
// black and the white card.
function Logo({
  color,
  width,
  height,
  src,
}: {
  color: string;
  width: string;
  height: string;
  src: string;
}) {
  return (
    <div
      className={color}
      style={{
        width,
        height,
        maskImage: `url(${src})`,
        WebkitMaskImage: `url(${src})`,
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
      }}
    />
  );
}

export function SponsorLogos({ variant }: SponsorLogosProps) {
  const logoColor = variant === 'hacker' ? 'bg-white' : 'bg-black';

  return (
    <div className="flex w-full flex-col gap-3">
      <div className="flex items-center justify-center gap-8">
        <Logo
          color={logoColor}
          width="180px"
          height="50px"
          src="/assets/logos/platanus.svg"
        />
        <Logo
          color={logoColor}
          width="100px"
          height="40px"
          src="/assets/logos/buk-crop.webp"
        />
      </div>

      <div className="flex items-center justify-center gap-6">
        <Logo
          color={logoColor}
          width="100px"
          height="33px"
          src="/assets/logos/anthropic-crop.svg"
        />
        <Logo
          color={logoColor}
          width="100px"
          height="33px"
          src="/assets/logos/fintoc-crop.png"
        />
        <Logo
          color={logoColor}
          width="115px"
          height="36px"
          src="/assets/logos/agendapro-crop.svg"
        />
        <Logo
          color={logoColor}
          width="100px"
          height="33px"
          src="/assets/logos/maxxa-crop.png"
        />
      </div>

      <div className="flex items-center justify-center gap-6">
        <Logo
          color={logoColor}
          width="50px"
          height="25px"
          src="/assets/logos/aws-crop.svg"
        />
        <Logo
          color={logoColor}
          width="75px"
          height="25px"
          src="/assets/logos/buda-crop.png"
        />
        <Logo
          color={logoColor}
          width="95px"
          height="32px"
          src="/assets/logos/runway-crop.png"
        />
        <Logo
          color={logoColor}
          width="100px"
          height="33px"
          src="/assets/logos/elevenlabs-crop.svg"
        />
      </div>
    </div>
  );
}
